import { render, staticRenderFns } from "./Thumbnail.component.vue?vue&type=template&id=255e0228"
import script from "./Thumbnail.component.vue?vue&type=script&lang=js"
export * from "./Thumbnail.component.vue?vue&type=script&lang=js"
import style0 from "./Thumbnail.component.vue?vue&type=style&index=0&id=255e0228&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports